import { Box, Typography } from '@mui/material';

import { getScoreColor } from '@/helpers/players-helper';

const FixtureScore = ({
    score,
    isAvailable,
    week,
    width,
    height,
    styles,
    isTransparent,
    pstyles,
    ...props
}) => {
    const DEFAULT_WIDTH = '24px';
    const DEFAULT_HEIGHT = '24px';

    const background =
        score || score === 0 ? getScoreColor(score, isAvailable, isTransparent) : 'transparent';

    const scoreText = isAvailable && background !== 'transparent' ? score : '-';

    return (
        <Box className="fixture-score-container" {...props}>
            <Box
                className="fixture-score-container__color"
                sx={{
                    background: background,
                    width: width ? width : DEFAULT_WIDTH,
                    height: height ? height : DEFAULT_HEIGHT,

                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '4px',
                    ...styles,
                }}
            >
                <Typography
                    sx={{
                        margin: 0,
                        padding: 0,
                        ...pstyles,
                        color: '#fff',
                        fontSize: pstyles?.fontSize ? pstyles?.fontSize : '12px',
                    }}
                >
                    {scoreText}
                </Typography>
            </Box>
            <Box className="fixture-score-container" sx={{ fontSize: '12px' }}>
                <Typography component={'span'}>{week ? 'J' + week : null}</Typography>
            </Box>
        </Box>
    );
};

export default FixtureScore;
